import React from 'react';

const ServiceConnectedDisabilityAddtlInfo = () => (
  <va-details label="How we define service-connected disability">
    <p>
      A Veteran had a service-connected disability if we concluded that they
      were disabled because of an illness or injury caused—or made worse—by
      their active-duty service.
    </p>
    <p>
      A Veteran was permanently and totally disabled if they had a disability
      that we rated as 100% disabling and that was not expected to improve.
    </p>
  </va-details>
);

export default ServiceConnectedDisabilityAddtlInfo;
